import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-stock-count-result',
  templateUrl: './stock-count-result.component.html',
  styleUrls: ['./stock-count-result.component.css']
})
export class StockCountResultComponent implements OnInit {
    stockCountKeyno;

    public selectedBgStockCountResultMain: string = 'DETAILS';

    public setting?: Setting;

    public gridDetails?: GridOptions;

    public gridLocations?: GridOptions;

    public gridValues?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockCountKeyno = this.stateService.getStateParams()['stockcount_keyno'];
    }

    private async loadSetting() {
        if (!!this.stockCountKeyno) {
            this.setting = (await this.datatask.Post(3452, { stockcount_keyno: this.stockCountKeyno }))[0];
        }
    }

    private loadGridDetails() {
        if (!this.gridDetails) {
            this.gridDetails = new Grid().setRememberId('w_stockcountresult_details_grid').setLoadDataFunction({ method: 3451, parameters: () => this.setting }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.gridDetails?.gridfunc?.read();
        }
    }

    private loadGridLocations() {
        if (!this.gridLocations) {
            this.gridLocations = new Grid().setRememberId('w_stockcountresult_stocklocations_grid').setLoadDataFunction({ method: 3453, parameters: () => this.setting }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.gridLocations?.gridfunc?.read();
        }
    }

    private loadGridValues() {
        if (!this.gridValues) {
            this.gridValues = new Grid().setRememberId('w_stockcountresult_values_grid').setLoadDataFunction({ method: 3454, parameters: () => this.setting }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.gridValues?.gridfunc?.read();
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGridDetails();
        this.loadGridLocations();
        this.loadGridValues();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    stockcount_keyno: string;
    stockplace_name: string;
    approved: string;
    stockcount_date: string;
    approved_date: string;
    stockcount_name: string;
    show_setting: string;
    reg_by_portal_user_name: string;
    approved_by_portal_user_name: string;
    stockplace_id: string;
    stockcount_status: string;
    nbr_of_stockcounts: string;
    badgeinfo: string;
    floating_location: string;
}
